/**
 * @param {boolean} isCustomLogin
 * @param {string[]} loginMethods
 * @returns {boolean}
 */
export function isValidCustomLoginMethod(isCustomLogin, loginMethods) {
  if (isCustomLogin && loginMethods.length < 1) {
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/user/index.js